module.exports = __webpack_public_path__ + "static/media/placeholder.ea9d6ccc.svg";